import React, { FC, PropsWithChildren } from 'react';
import {
  // RouterProvider,
  // createBrowserRouter,
  unstable_HistoryRouter as HistoryRouter,
} from 'react-router-dom';

// import App from './App';
// import NotFoundPage from './layout/NotFoundPage';
// import { BaseLayout } from './layout/Layout';
import { routerHistory } from '#/reduxState/router/routerReducer';

import App from './App';

// const browserRouter = createBrowserRouter([
//   {
//     path: '/*',
//     element: <App />,
//     loader: () => <div />,
//     errorElement: (
//       <BaseLayout>
//         <NotFoundPage />
//       </BaseLayout>
//     ),
//   },
// ]);
// export const getBrowserRouter = () => browserRouter;

const CustomRouter: FC<PropsWithChildren> = ({ children, ...props }) => {
  return (
    <HistoryRouter history={routerHistory as any} {...props}>
      {children}
    </HistoryRouter>
  );
};

export default function AppEntry() {
  // return <RouterProvider router={browserRouter} />;
  return (
    <CustomRouter>
      <App />
    </CustomRouter>
  );
}
